import { render, staticRenderFns } from "./bespeak.vue?vue&type=template&id=ebc55b46&scoped=true"
import script from "./bespeak.vue?vue&type=script&lang=js"
export * from "./bespeak.vue?vue&type=script&lang=js"
import style0 from "./bespeak.vue?vue&type=style&index=0&id=ebc55b46&prod&lang=less&scoped=true"
import style1 from "./bespeak.vue?vue&type=style&index=1&id=ebc55b46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc55b46",
  null
  
)

export default component.exports